export default {
    waitingArea:'зал ожидания',
    guidedLanding:'управляемая посадка',
    landHeight:'высота ожидания падения',
    conversionHeight:'Преобразовать высоту',
    flySpeed:'скорость полета',
    entryDirection:'направление подхода',
    landingPosition:'Место посадки',
    mapPosition:'Выбор точки карты',
    uavPosition:'Текущее положение дрона',
    landingParameters:'параметры посадки',
    landingPointAltitude:'Высота точки приземления',
    recyclingLandingParameters:'Динамическое восстановление параметров приземления',
    waitingAreaRadius:'Радиус зоны ожидания',
    waitingAreaHeight:'Относительная высота зоны ожидания',
    waitingAreaDistance:'Расстояние от зоны ожидания до места приземления',
    guidanceSpeed:'Скорость загрузочного сегмента',
    goAroundHeight:'Высота набора высоты при уходе на второй круг',
    recyclingExpandParameters:'Динамическая переработка расширенных параметров',
    conversionPointHeight:'Высота точки преобразования',
    otherModels: 'Другие модели',
    HUTF: 'Подвесьте неподвижное крыло',
    upgrading: 'модернизация',
    //header部分
    set: 'Настройки наземной станции',
    logout: 'выход',
    noSignal: 'нет сигнала',
    setting: 'Настраивание',
    news: 'Новости',
    user: 'Пользователь',
    em: 'Управление устройствами',
    dataLink: 'Канал передачи данных',
    connected: 'связанный',
    notConnected: 'Не подключен',
    strongSignal: 'Сильный сигнал',
    weakSignal: 'Слабый сигнал',
    windSpeed: 'Скорость ветра',
    windDirection: 'направление ветра',
    temperature: 'температура',
    humidity: 'влажность',
    airPressure: 'Давление воздуха',
    weatherStation: 'Метеостанция',
    urgent: 'Срочный',
    high: 'Высокий',
    medium: 'Средний',
    low: 'Низкий',
    usedFlow: 'Использованный поток',
    residualFlow: 'Оставшийся поток',
    page: '{index}D-страница',
    //辅助信息部分
    errMsg: 'Неверная информация',
    moreTools: 'Дополнительные инструменты',
    flightMode: 'Режим полета',
    targetPoint: 'Следующая путевая точка',
    distance: 'расстояние',
    currentPOS: 'Текущее местоположение：',
    fail: 'Не удалось получить информацию',
    normal: 'Все в порядке, можно взлететь. ',
    debugging: 'Помощник по отладке',
    flightLog: 'Журнал полетов',
    sensor: 'Калибровка датчика',
    journal: 'дневник полетов',
    devTools: 'Инструменты разработчика',
    flightTime: 'Время полета',
    flightDistance: 'Расстояние полета',
    generalConfig: 'Общая конфигурация',
    RTKSettings: 'Параметры RTK',
    AC: 'Калибровка калькулятора ускорения',
    CC: 'Калибровка компаса',
    RC: 'Калибровка коромысла',
    LC: 'Горизонтальная калибровка',
    VC: 'Вертикальная калибровка',
    MT: 'Тестирование двигателя',
    getList: 'Получить список',
    snatchSession: 'Рывок сессия',
    downloadMachine: 'Загрузите эту машину',
    cancelDownload: 'Отменить скачивание',
    downloadAgain: 'скачать снова',
    size: 'размер',
    batteryInformation: 'информация о батарее',
    batteryType: 'Тип аккумулятора',
    electricity: 'Электричество',
    voltage: 'Напряжение',
    current: 'ток',
    notAcquired: 'не приобретенный',
    productionDate: 'Дата производства',
    parachuteSelfCheckStatus: 'Самоконтроль парашюта',
    parachuteOpeningStatus: 'режим раскрытия парашюта',
    selfCheckPassed: 'Самоконтроль прошел',
    selfTestFailed: 'Самопроверка не прошла',
    locked: 'Заблокировано',
    unlocked: 'Разблокировано',
    umbrellaOpened: 'Открыт парашют',
    // speed:'скорость',
    enter: 'входить',
    download: 'скачать',
    //工具栏
    uavList: 'Список беспилотников',
    map: 'карта',
    video: 'видео',
    taskManagement: 'Управление миссиями',
    fastTask: 'скоростная задача',
    quickPuzzle: 'Быстрая головоломка',
    achievementDisplay: 'демонстрировать результаты',
    tagManagement: 'Управление метками',
    electronicFence: 'электронное ограждение',
    CT: 'Преобразование координат',
    degrees: 'градусы',
    DMS: 'градусы минута секунда',
    measuring: 'измерить',
    waypointEditor: 'Редактирование путевых точек',
    routeEditor: 'Редактирование маршрута',
    routeTemplate: 'Шаблоны маршрутов',
    arbitraryFlight: 'Управляемый полет',
    clearTrajectory: 'Очистить следы',
    DOH: 'Двухлегкий карданный подвес',
    megaphone: 'Мегафон',
    LS: 'Настройка нагрузки',
    VFS: 'Видео во весь экран',
    pictureLayout: 'Схема изображения',
    PTZSetting: 'Настройка облачной платформы',
    clearMeasurementLayer: 'Очистить измерительный слой',
    formationFlying: 'летающий строй',
    robotDog: 'робот-собака',
    //航点编辑
    reverse: 'Обратный порядок',
    cycles: 'Количество циклов',
    height: 'высота',
    speed: 'скорость',
    waypointMode: 'Режим путевой точки',
    turnMode: 'Режим поворота',
    radius: 'радиус',
    altitude: 'высота',
    time: 'Время оставления',
    editWP: 'Исправить путевой точки',
    editPosition: 'Изменение координат',
    azimuth: 'азимут',
    editDirection: 'Изменение азимута',
    complete: 'Завершить добавление',
    added: 'Добавление путевых точек',
    insert: 'Вставка путевых точек',
    save: 'Сохранить список маршрутов',
    openRouteList: 'Открыть список маршрутов',
    open: 'Открытым',
    del: 'Удаление путевых точек',
    revoke: 'отменять',
    redo: 'переделать',
    home: 'Обратно',
    editHome: 'исправить обратно',
    editComplete: 'исправить закончил',
    goHome: 'Выполнить обратно',
    noHome: 'обратная точка нет планирования',
    circlingDirection: 'Направление вращения',
    clockwise: 'По часовой стрелке',
    counterclockwise: 'Против часовой стрелки',
    liftMode: 'Лифт режим',
    liftImmediately: 'Поднимите немедленно',
    highProtection: 'Высокая защита',
    circlingRadius: 'Радиус поворота',
    readHoming: 'Читать самонаведение',
    nosePointing: 'нос указывает',
    followTheRoute: 'следовать маршруту',
    target: 'Цель',
    courseModification: 'модификация курса',
    device: 'устройство',
    action: 'действие',
    serialNumber: 'серийный номер',
    routeClosed: 'маршрут закрыт',
    export: 'Экспорт {0}',
    import: 'импорт {0}',
    position: 'позиция',
    upload: 'загрузить',
    imageSwitching: 'Переключение изображений',
    rowsColumns: 'Обнаружено：{rows} строки,{cols} столбца',
    latLngStart: 'стартовая линия широты и долготы',
    column: 'столбец {0}',
    whichColumn: 'Колонка {0}',
    LPRM: 'Режим распознавания номерных знаков',
    batchEdit: 'Пакетное редактирование',
    //航线编辑
    routeNumber: 'номер маршрута',
    routeHeight: 'Высота маршрута',
    routeSpeed: 'Скорость маршрута',
    remainingTimes: 'Количество оставших',
    routeEndAction: 'Завершенные действия',
    routeEntryPoint: 'Точка входа в маршрут',
    routeLength: 'Длина маршрута',
    estimatedFlightTime: 'Планируемое время полета',
    rotation: 'Верчение',
    translation: 'поступательное движение',
    //航线模板
    triangle: 'треугольник',
    rectangle: 'Прямоугольник',
    polygone: 'многоугольник',
    round: 'кругло',
    scan: 'сканирование',
    sideLength: 'Длина',
    RH: 'высота',
    startToEnd: 'закрыто',
    length: 'длина',
    width: 'Ширина',
    number: 'количество',
    addArea: 'Добавить регион',
    scanAngle: 'Угол сканирования',
    scanInterval: 'Интервал сканирования',
    scanArea: 'Область сканирования',
    Import: 'Импорт редактора путевых точек',
    inSurvey: 'Идет измерении, пожалуйста, сначала завершите измерение',
    scanIntervalFormat: 'Минимальный интервал сканирования составляет 1',
    STA: 'Сканируйте этого область',
    repaint: 'перерисовка',
    photoShootingMethod: 'Как фотографировать',
    photoInterval: 'Интервал фото',
    //指点飞行
    hoverTime: 'время ожидания',
    timeoutAC: 'Действия превышает время',
    enterPointingFlightMode: 'вход в шаблон управляемого полета',
    exitAdvice: 'Выход из шаблона управляемого полета',
    startExecution: 'Начать выполнение',
    noPointing: 'Пожалуйста, сначала планируйте положение управляемого полета',
    pointingFlight: 'Управляемый полет',
    isPointingFlight: 'Начать ли управляемый полет?',
    IAL: '0 всегда цикл',
    pointingDistance: 'Расстояние наведения',
    returnFlight: 'Обратный рейс',
    landing: 'посадка',
    //航线列表
    routeList: 'Список маршрутов',
    routeName: 'Название маршрута',
    search: 'поиск',
    createTime: 'Время создания',
    operation: 'оперировать',
    use: 'использовать',
    noUaerid: ' пустой ID пользователя',
    share: 'поделиться',
    merge: 'объединять',
    dragSort: 'Сортировка перетаскиванием',
    routeRemarks: 'Примечания к маршруту',
    relativeAltitudeRoute: 'маршрут относительной высоты',
    altitudeRoute: 'высотный маршрут',
    PETN: '0 ~ 100 символов в длину',
    //操作按钮
    endPperation: 'Завершите испытательный полет. ',
    takeoverControl: 'контролировать забирание обратно',
    releaseControl: 'контролироватьвыделение',
    uavLocation: 'определить место самолёта',
    executionRoute: 'маршрутный полёт',
    takeOff: 'Автоматический взлет',
    flightSuspension: 'Приостановление полета',
    flightContinue: 'Продолжать летать. ',
    land: 'посадка',
    directReturn: 'Прямой повернуть обратно',
    trackReturn: 'повернуть обратно на ту же дорогу',
    manual: 'ручное управление',
    emergencyStop: 'аварийная остановка',
    loadControl: 'Управление нагрузкой',
    SC: 'Контроль скорости',
    HC: 'Контроль высоты',
    NOU: 'Количество беспилотников',
    DP: 'точка связи по умолчанию',
    CSQ: 'Выбранное в данный момент количество',
    TOS: 'Порядок взлета',
    meanwhile: 'Взлетать одновременно',
    delayed: 'Отложенный взлет',
    delayedTakeoff: 'Отложенный взлет',
    emergency: 'Чрезвычайная ситуация',
    RTF: 'Готов к полету',
    unlock: 'Разблокировать',
    takeoff: 'Взлететь',
    route: 'маршрут',
    waypoint: 'Путевая точка',
    cycle: 'цикл',
    unlimited: 'неограниченный',
    EATN: 'Введите после конца',
    homingHovering: 'Самонаведение парение',
    homingLanding: 'Cамонаводящаяся посадка',
    CLR: 'Изменить маршрут посадки',
    executeImmediately: 'Выполнить немедленно',
    returnHome: 'Вернуться домой',
    flightControl: 'Регулирование полёта',
    standardLanding: 'Стандартная посадка',
    MRL: 'Многороторная посадка',
    MRQRL: 'Многороторный возврат и посадка',
    FWA: 'Запасной самолет',
    sprayOn: 'Распылите на',
    sprayOff: 'Распылите',
    moreInstructions: 'Дополнительные инструкции',
    spraySetting: 'Настройка распыления',
    typesOf: 'Виды',
    WPL: 'Водяной насос-левый',
    WPR: 'Водяной насос-правый',
    WPF: 'Водяной насос заполнен',
    NV: 'Численная величина',
    actionOn: 'Действие на',
    actionOff: 'Действие выключено',
    startPuzzle: 'начать головоломку',
    endPuzzle: 'конец головоломки',
    aisle: 'ряд',
    left: 'Осталось',
    right: 'правильно',
    proportion: 'Доля',
    return: 'вернуть',
    airlineFlight: 'Рейс авиакомпании',
    routePerformed: 'Маршрут, который необходимо выполнить',
    entryPoint: 'входная точка',
    waitExecutionTime: 'ждать время выполнения',
    entryPointError: 'ошибка точки входа',
    intervalSendTime: 'Интервал отправки',
    deviceFunction: 'Функция устройства',
    configure: 'настроить',
    without: 'без',
    gimbalDown: 'Bниз PTZ',
    gimbalReset: 'Сброс PTZ',
    followMode: 'режим следования',
    courseLock: 'блокировка курса',
    freeMode: 'свободный режим',
    MRLIP: 'Мультироторная посадка на месте',
    MRFRL: 'Многороторный возврат и посадка',
    rotorAlternate: 'альтернативный ротор',
    fixedWingAlternate: 'альтернативный самолет с неподвижным крылом',
    startFromThePointcut: 'Начнем с точки входа',
    startFromTheStartingPoint: 'Начнем с начала',
    executionOrder: 'Порядок выполнения',
    heightAdjustment: 'Регулировка высоты',
    speedAdjustment: 'Регулировка скорости',
    reset: 'перезагрузить',
    oneKeyDown: 'Один клик вниз',
    followTheAircraftHead: 'Следуй за носом',
    // 通用配置
    ATOWR: 'разрешать взлет без RTK ',
    CM: 'подъёмно-переставный шаблон',
    tilt: 'наклоняться подъёмно-переставнение',
    vertical: 'вертикальное подъёмно-переставнение',
    cycleMode: 'тип цикла модуля',
    BP: 'точка связи',
    SP: 'начальная точка',
    RA: 'Высота повернуть обратно',
    HL: 'ограничение по высоте полёта',
    RS: 'Скорость повернуть обратно',
    returnHomingDirection: 'Направление возвращения / возвращения',
    headOrientation: 'Направление носа',
    tailOrientation: 'Направление хвоста',
    securitySetting: 'Параметры безопасности',
    TOWPIA: 'Разрешить взлет без парашюта',
    AWAF: 'После неудачного движения',
    continueTheRoute: 'Продолжайте курс',
    waitFor: 'Ожидание',
    RCOOCP: 'защита дистанционное управления без контроля',
    linkRunawayProtection: 'Защита от неконтролируемой связи',
    NA: 'нет действии',
    hover: 'зависание',
    returnH: 'повернуть обратно(по прямой линию)',
    EA: 'каличество электричества бить тревогу',
    FLA: 'Сигнализация первого уровня',
    EQ: 'каличество электричества',
    PS: 'протекционистская политика',
    SALA: 'Звуковая и световая сигнализация',
    SA: 'Вторичная сигнализация',
    aileron: 'элерон',
    lift: 'поднимать',
    accelerator: 'ускоритель',
    direction: 'направление',
    airplaneMode: 'авиа режим',
    output: 'выход',
    test: 'тестовое задание',
    channelTest: 'тест канала',
    singleShot: 'одиночный выстрел',
    continuousShooting: 'непрерывная съемка',
    oneShot: 'Один выстрел',
    burstStarts: 'Взрыв начинается',
    burstEnds: 'Всплеск заканчивается',
    pitch: 'подача',
    roll: 'рулон',
    yaw: 'курс',
    flowRate: 'расход',
    minimum: 'минимум',
    maximum: 'максимум',
    automatic: 'автоматический',
    close: 'близко',
    currentChannel: 'Текущий канал',
    trigger: 'вызывать',
    flightParameters: 'Параметры полёта',
    heightLimit: 'Ограничение высоты пульта дистанционного управления',
    flightSpeed: 'скорость полёта на пульте дистанционного управления',
    outputChannelBinding: 'привязка выходного канала',
    inputChannelMapping: 'Отображение входного канала',
    protectiveFunction: 'Защитная функция',
    flightInspection: 'летная инспекция',
    sensorStatus: 'состояние датчика',
    thrustTest: 'испытание тяги',
    turnOffImmediately: 'немедленно выключить',
    abortAction: 'прервать действие',
    rotorReadyToTakeOff: 'Ротор готов к взлету',
    rotorAttitudeThrottle: 'Дроссель положения ротора',
    rotorPositioningRemoteControl: 'Дистанционное управление позиционированием ротора',
    FWRS: 'дистанционное управление рулем направления с неподвижным крылом',
    FWAR: 'Дистанционное управление неподвижным крылом',
    joystickStatus: 'состояние джойстика',
    magneticCompass: 'магнитный компас',
    japaneseHand: 'японская рука',
    americanHand: 'американская рука',
    chineseHand: 'Chinese hand',
    antiJapaneseHand: 'антияпонская рука',
    dataLinkConnection: 'соединение канала передачи данных',
    internalGNSSSystem: 'Внутренняя система GNSS',
    rockerConnection: 'кулисное соединение',
    externalGNSSSystem: 'Внешняя система GNSS',
    flightControlMode: 'режим управления полетом',
    navigationState: 'Состояние навигации',
    fixedWingThrottle: 'дроссельная заслонка с неподвижным крылом',
    rotorThrottle: 'дроссель ротора',
    ATP: 'Параметры автоматического взлета',
    presetClimbAltitude: 'Предустановленная высота набора высоты',
    fixedWing: 'FW',
    multiRotor: 'MC',
    timeProtection: 'защита времени',
    protectionMethod: 'Способ защиты',
    notProtected: 'не защищен',
    protectionTime: 'время защиты',
    // 云台
    SR1: 'начало снимать на видеокамеру',
    SR2: 'прекращать снимать на видеокамеру',
    photograph: 'фотографировать',
    zoom: 'изменение фокуса',
    IAOR: 'Внутренний угол маршрута',
    targetLock: 'целевая блокировка',
    targetUnlock: 'цель разблокировать',
    infraredSwitching: 'Инфракрасное переключение',
    recordingNotTurnedOn: 'Запись не включена',
    solveTargetPosition: 'Решите целевую позицию',
    startTargetRecognition: 'Начать распознавание цели',
    stopTargetRecognition: 'Остановить распознавание цели',
    targetRecognitionStatistics: 'Статистика распознавания целей',
    videoFrameSelection: 'Выбор видеокадра',
    confirmTracking: 'Подтвердить отслеживание',
    licensePlateRecognition: 'Распознавание номерных знаков',
    getFlightControl: 'Получить контроль полета',
    // 车牌识别
    pictureList: 'Список фотографий',
    shootingDate: 'Дата съемки',
    unrecognized: 'непризнанный',
    sameDay: 'в тот день',
    twoDays: 'два дня',
    threeDays: 'три дня',
    aWeek: 'одна неделя',
    // 喊话器
    startRecording: 'начать запись',
    playRecording: 'Воспроизвести запись',
    volume: 'объем',
    // 画面设置
    resolutionSetting: 'Настройки изображения',
    videoStreaming: 'Видеоконструкция',
    format: 'формат',
    resolution: 'разрешение',
    codeRate: 'Коэффициент',
    // 高程信息
    elevationInformation: 'Информация о высоте',
    numbering: 'Нумерация',
    details: 'Подробности',
    // 电子围栏
    model: 'модель',
    polygonElectricFence: 'Полигон Электрический забор',
    startPicking: 'начать собирать',
    endPicking: 'конечная точка',
    clearPicking: 'четкая точка',
    read: 'читать',
    // 载荷
    megaphoneLoad: 'мегафон нагрузка',
    play: 'играть',
    selectFile: 'выберите файл',
    siren: 'сирена',
    textPlay: 'воспроизведение текста',
    // 任务成果
    taskOutcome: 'Результат миссии',
    taskName: 'название миссии',
    aerialSurveyMission: 'аэрофотосъемка',
    taskType: 'тип задачи',
    startAndEndTime: 'Время начала и окончания',
    start: 'Начинать',
    end: 'Kонец',
    address: 'адрес',
    generateTarget: 'Создать цель',
    // 生命探测记录
    lifeDetection: 'обнаружение жизни',
    uavName: 'Имя дрона',
    flightAltitude: 'высота полета',
    signalDistance: 'Расстояние сигнала',
    confirm: 'подтверждать',
    suspected: 'подозреваемый',
    collectionTime: 'Время сбора',
    positionCoordinates: 'Координаты положения',
    signalStrength: 'сила сигнала',
    strongest: 'сильнейший',
    realTime: 'в реальном времени',
    startDetection: 'Начать обнаружение',
    endDetection: 'концевой зонд',
    // 编队飞行
    formationMainRouteEdit: 'Основной маршрут формирования',
    totalNumberFormations: 'Общее количество стоек',
    executeNextRoute: 'Выполнить следующий маршрут',
    delayActionTime: 'Время действия задержки',
    formationEditor: 'Редактор формации',
    saveFormationFile: 'Сохранить файл формации',
    formationFileList: 'Formation File List',
    uploadFormationRoute: 'Загрузить маршрут формирования',
    uavNumber: 'Номер дрона',
    formationFileName: 'Имя файла формации',
    editName: 'Редактировать имя',
    editFile: 'Редактировать файл',
    cellDistance: 'Расстояние до ячейки',
    offsetDirectionAngle: 'Угол направления смещения',
    axisOffset: 'Смещение оси {name} (метры)',
    formation: 'Формирование {msg}',
    topView: 'вид сверху',
    rightView: 'вид справа',
    frontView: 'вид спереди',
    // RTK设置
    rtkFrontView: 'Текущий статус РТК',
    normalOK: 'Нормально',
    noService: 'нет обслуживания',
    dataForwardingType: 'Тип пересылки данных',
    BAUOBS: 'Привязка и отвязка базовых станций',
    encryptionMode: 'режим шифрования',
    publicMode: 'Публичный режим (без пароля)',
    linkingPassword: 'Привязка пароля',
    ntripHostAddress: 'Адрес NtripHost',
    port: 'порт',
    username: 'имя пользователя',
    password: 'пароль',
    mountPoint: 'Точка монтирования',
    notUsingRTK: 'Не использую RTK',
    confirmAdjustment: 'Подтвердите настройку',
    standardNetwork: 'стандартная сеть',
    otherNetwork: 'Другие сети',
    localNetwork: 'локальная сеть',
    customNetwork: 'Пользовательская сеть',
    doNotUse: 'Не использовать',
    allocationConfirmation: 'подтверждение распределения',
    allocationSuccessful: 'Распределение выполнено успешно',
    allocationFailed: 'Не удалось распределить',
    aiRecognitionStatistics: 'Статистика распознавания ИИ',
    pedestrian: 'пешеход',
    vehicle: 'транспортное средство',
    imageZoom: 'Увеличение изображения',
    imageReduction: 'Уменьшение изображения',
    // 提示
    tips_routerSportNumber: 'Пожалуйста, запланируйте по крайней мере две точки маршрута',
    tips_MD: 'Удаление измерения слоя прошло успешно',
    tips_MStart: 'Начало измерения',
    tips_MEnd: 'Конец измерения',
    tips_noSelectUAV: 'Невыбранный дрон，следует ли переключаться в автономный режим?',
    tips_noSelectRS: 'Пожалуйста, выберите путевую точку',
    tips_SelectRS: 'Пожалуйста, выберите хотя бы одну путевую точку',
    tips_errA: '{uav} существует {err} помеха, пожалуйста, разберитесь с этим как можно скорее',
    tips_inputError: '{name} введите ошибку',
    tips_HInputError: 'Ввод высоты неверен',
    tips_SInputError: 'Ввод скорости неверен',
    tips_SO: 'Успешная операция',
    tips_AF: 'добавление завершает',
    tips_isD: 'Точно ли удалить?',
    tips_loopErr: 'Вводите количество циклов неувереный!',
    tips_Upload: 'закачивал на сервер!',
    tips_RName: '1 ~ 20 символов в длину',
    tips_noRoute: 'Пожалуйста, сначала планируйте свой маршрут. ',
    tips_ALT: 'Пожалуйста, запланируйте по крайней мере две точки маршрута',
    tips_IEP: 'Точка связи неверный ввод',
    tips_PEP: 'Пожалуйста, введите точеку связи',
    tips_endspot: 'Последней точкой маршрута может быть только посадка, возвращение или повернуть обратно',
    tips_planFailure: 'Ошибки планирования путевых точек',
    tips_crosNoFly: 'Маршрут не может пересекать бесполетную зону, пожалуйста, перепланируйте его',
    tips_RTRF: 'Маршрут проходит через ограниченную зону (высота<=300m)，пожалуйста, перепланируйте его',
    tips_IIPT: 'Маршрут может быть пересекать бесполетную зону, пожалуйста, перепланируйте его',
    tips_homingNoFly: 'Точка возврата не может находиться в бесполетной зоне, пожалуйста, перепланируйте его',
    tips_HPEF: 'Точка возврата должна находиться в пределах электронного ограждения, пожалуйста, перепланируйте его',
    tips_PFNoFly: 'Управление полета не может осуществляться в бесполетной зоне, пожалуйста, перепланируйте его',
    tips_PFEF: 'Управление полета должна находиться в пределах электронного ограждения, пожалуйста, перепланируйте его',
    tips_EFNoFly: 'Маршрут должна находиться в пределах электронного ограждения, пожалуйста, перепланируйте его',
    tips_enterAreaMeas: 'Пожалуйста, введите описание слоя измерения площади',
    tips_takeOver: 'Владелец вернул себе контроль',
    tips_endTakeOver: 'Ваш испытательный полет окончен, уходите ли из систему?',
    dist: 'расстояние',
    relativeDist: 'Относительное расстояние',
    angle: 'угол',
    relativeAngle: 'Относительные углы',
    tip_AETMCA: 'Высота полета превышает максимальную крейсерскую высоту',
    tip_TRETMSR: 'Радиус превышает максимальный безопасный радиус',
    // Советы по калибровке
    tip_CC: 'Калибровка завершена',
    tip_ESCTC: 'входите код SN, чтобы утверждать',
    tip_ICAYSTC: 'Идёт калибровки, определите, следует ли отменять？',
    tip_UIFPTAL: 'Беспилотник летит, пожалуйста, повторите попытку позже. ',
    tip_KAFEIAC: 'После начала калибровки держитесь подальше от электромагнитных помех',
    tip_DNMTAACB: 'Не перемещайте беспилотник после начала калибровки',
    tip_BSTRAPFT: 'Обязательно снимите все пропеллеры для тестирования',
    tip_PKTPLITFD: 'Пожалуйста, держите самолет в прямом направлении и горизонтальном положении',
    tip_PKTNDAV: 'Пожалуйста, держите самолет головой вниз и вертикально',
    tip_PKTNU: 'Пожалуйста, держите самолет головой вверх и вертикально',
    tip_PKTLSOTAFDV: 'Пожалуйста, держите самолет на левой стороне лицом вниз и вертикально',
    tip_PKTRSOTAFDV: 'Пожалуйста, держите самолет на правой стороне лицом вниз и вертикально',
    tip_PKTPIRAHP: 'Пожалуйста, держите самолет в обратном горизонтальном положении',
    tip_PKTPLARAA: 'Поверните дрон 3 раза с постоянной скоростью, затем переверните его на 180 градусов по горизонтали в перевернутое состояние и снова поверните его 3 раза с постоянной скоростью.',
    tip_PKTLSOTPFDARAACS: 'Пожалуйста, держите самолет на левой стороне лицом вниз, вращайтесь с одинаковой скоростью',
    tip_PKTANUARAACS: 'Пожалуйста, держите самолет головой вверх, вращайтесь с одинаковой скоростью',
    tip_PKARCP: 'Пожалуйста, держите все дистанционные панели нейтральными и нажмите кнопку Начать калибровку пульта дистанционного управления',
    tip_PTTRET: 'Пожалуйста, равномерно поверните джойстик, чтобы коснуться предельного положения',
    tip_PKAPN: 'Пожалуйста, держите все дистанционные панели нейтральными',
    tip_PKTNS: 'Пожалуйста, держите самолет головой вверх и покой，Горизонтальный угол более 70°',
    tip_VL: 'Идёт загрузить видео',
    // Общие размещение по настройке
    tip_RACBE: 'Возвратная высота не может быть пустой',
    tip_PEANV: 'Пожалуйста, введите целое число',
    tip_RAMBG: 'Высота возврата должна быть больше или равна 5',
    tip_TRAMB: 'Высота возврата должна быть меньше ограничной высоты',
    tip_HLCBE: 'Ограничение по высоте не может быть пустым',
    tip_HLR: 'Диапазон предельной высоты 3~500',
    tip_RSCBE: 'Скорость возврата не может быть пустой',
    tip_RSR: 'Диапазон скорости возврата 2~10',
    tip_SDT: 'Имитация тайм-аута дрона',
    tip_LAL: 'Ошибка ввода долготы и широты, введите повторно',
    tip_enterHeading: 'Пожалуйста, введите угол курса',
    tip_addTargetPoint: 'Пожалуйста, добавьте целевую точку',
    tip_WACO: 'Действия с путевыми точками могут изменять только одну путевую точку за раз',
    tip_selectDev: 'Пожалуйста, выберите устройство',
    tip_selectAction: 'Выберите действие',
    tip_enterInte: 'Пожалуйста, введите целое число',
    tip_TSVO: 'Минимальное значение параметра действия равно',
    tip_TMVOT: 'Максимальное значение параметра действия равно',
    tip_enterAction: 'Пожалуйста, введите параметры действия',
    tip_TIAB: 'На текущем маршруте есть точка останова, вы хотите лететь с точки останова?',
    tip_TDWA: 'Дрон автоматически взлетит и зависнет, введите высоту зависания (целое число 1~200)',
    tip_HHIE: 'Ошибка ввода высоты наведения',
    tip_enterImgSwitching: 'Пожалуйста, введите значение ШИМ для переключения изображений',
    tip_enterSinglePhoto: 'Пожалуйста, введите значение ШИМ для одной фотографии',
    tip_enterStartCS: 'Введите значение ШИМ, чтобы начать непрерывную съемку.',
    tip_enterEndCS: 'Пожалуйста, введите значение ШИМ для окончания непрерывной съемки',
    tip_TPVF: 'Значения ШИМ для начала и окончания непрерывной съемки не могут быть равны',
    tip_enterAngle: 'Пожалуйста, введите значение угла',
    tip_enterPWM: 'Пожалуйста, введите значение ШИМ',
    tip_PWMVCBE: 'Значения ШИМ не могут быть равны',
    tip_PWMCBE: 'ШИМ не может быть пустым',
    tip_FRCB: 'Скорость потока не может быть пустой',
    tip_TMVO: 'Минимальное значение ШИМ меньше максимального значения',
    tip_TMVOF: 'Минимальное значение расхода меньше максимального значения',
    tip_enterPWMoff: 'Введите значение ШИМ для выкл.',
    tip_enterPWMon: 'Пожалуйста, введите открытое значение PWM',
    tip_OAOP: 'OFF и ON значения PWM не могут быть равны',
    tip_EPSR: 'Пожалуйста, введите значение ШИМ, чтобы начать запись',
    tip_EPER: 'Пожалуйста, введите значение ШИМ, чтобы закончить запись',
    tip_TPVOS: 'Значения ШИМ начала записи и окончания записи не могут быть равны',
    tip_APEF: 'Многоугольный электронный забор требует не менее трех точек',
    tip_TSAR: 'Диапазон углов сканирования составляет -360~360°.',
    tip_ANWS: 'Число с длиной стороны больше 0',
    tip_LIAN: 'Длина — это число больше 0',
    tip_WIAN: 'Ширина - это число больше 0',
    tip_ANWA: 'Число с радиусом больше 0',
    tip_PITV: 'пожалуйста, введите значение',
    tip_TIDTD: 'В редакторе маршрута есть данные, не соответствующие формату',
    tip_TIMTO: 'В настоящее время проверено более одного списка дронов, и точка входа не может быть установлена.По умолчанию 1.',
    tip_fileError: 'Ошибка файла, проверьте правильность содержимого файла',
    tip_pleaseEnterKeyword: 'Пожалуйста, введите ключевое слово',
    tip_REAEM: 'Редактор маршрута: высота превышает максимальную крейсерскую высоту',
    tip_REREM: 'Редактор маршрута: Радиус превышает максимально безопасный радиус',
    tip_TWTOUA: 'Время ожидания дрона после получения команды',
    tip_ISTOCC: 'Контроль времени передачи команд',
    tip_YCDTLY: 'Можно перетаскивать список вверх и вниз для сортировки выполнения дронов.',
    tip_PSTRTB: 'Выберите маршрут, который необходимо выполнить.',
    tip_PMST: 'Пожалуйста, убедитесь, что устройство обнаружения жизни подключено к дрону!',
    tip_TDPT: 'Процесс обнаружения каждый раз занимает 5-10 минут, пожалуйста, обратите внимание на данные обнаружения!',
    tip_TNOA: 'Количество самолетов в строю 0, введите количество самолетов в строю!',
    tip_TMRI: 'Основной маршрут пуст, пожалуйста, спланируйте основной маршрут!',
    tip_PETF: 'Пожалуйста, введите имя файла формации',
    tip_EBSN: 'Введите номер базовой станции для поиска',
    tip_TPBS: 'Сторонним базовым станциям необходимо обратиться к администратору для их активации или деактивации.',
    tip_TRSH: 'Дрону (SN: {id1}) назначена служба RTK. Если настроить ее на текущий дрон (SN: {id2}), исходный дрон больше не будет получать дифференциальные данные сети RTK после подтверждения.',
    tip_ANRA: 'Текущему воздушному судну назначена другая сетевая учетная запись RTK (служебный номер: {rtkKey}), и дифференциальные данные можно получить обычным способом.',
    tip_TRSI: 'Служба RTK не активирована, и дифференциальные данные не могут быть получены.',
    tip_TRSHE: 'Срок действия услуги RTK истек, и дифференциальные данные невозможно получить.',
    tip_FEPE: 'Ошибка формата. Введите целое число от 1 до 65535!',
    tip_PCALP: 'Пожалуйста, выберите точку посадки',
    tips_THPMB: 'Точка возврата должна находиться внутри электронного ограждения, пожалуйста, спланируйте еще раз.',
    tips_PETT: 'Пожалуйста, введите идентификатор цели',
    tips_ITCR: 'Пройти текущий маршрут?',
    tips_DTCP: 'Перетащите, чтобы изменить положение.',
    tips_HDTA: 'Удерживая клавишу Alt, перетащите вверх или вниз, чтобы изменить высоту.',
    tips_ASPT: 'После выбора нажмите клавишу «Delete», чтобы удалить.',
    tips_TDCB: 'Дрон нельзя повторить, выберите еще раз!',
    tips_TVSC: 'Источник видео не может быть повторен, выберите еще раз!',
    tips_WAHA: 'Waypoint {number} уже имеет изохронное фото-действие, пожалуйста, не добавляйте его снова.',
    tips_WAHAE: 'В Waypoint {number} уже есть изометрический фотоэкшен, не добавляйте его снова.',
    tips_PETP: 'Пожалуйста, введите значение ШИМ для усиления изображения',
    tips_PETPR: 'Пожалуйста, введите значение ШИМ для уменьшения изображения.',
    tips_TPVF: 'Значения ШИМ увеличения и уменьшения изображения не могут быть равными',
}